
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `PayMethod/list`,
  meta: `PayMethod/listMeta`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `PayMethod/setListOption`,
  reload: `PayMethod/fetchList`,
  pagePrev: `PayMethod/pagePrev`,
  pageNext: `PayMethod/pageNext`,
  deleteItem: `PayMethod/remove`,
})

methods.edit = function (id) {
  this.$emit(`editrequest`, id)
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({ search: value })
}


/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  if (this.meta.filter.format !== `deep`) {
    this.setListOption({ format: `deep` })
  }
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th width="200" class="text-left">Metode Pembayaran</th>
        <th class="text-left">Akun</th>
        <th width="80" class="text-left">Potongan </th>
        <th width="80" class="text-left"></th>
        <th width="40" class="text-right"></th>
      </template>

        <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">
            <span class="link underlined" @click="edit(item.id)">{{ item.name }}</span>
          </td>
          <td class="text-left" v-html="item.account_name"></td>
          <td class="text-left">
            <label v-if="item.cost_is_percent" class="label label-success">Persen</label>
            <label v-if="item.cost_is_fixed" class="label label-warning">Fixed</label>
          </td>
          <td class="text-right" v-html="item.cost_readable"></td>
          <td class="text-right">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>